import { render, staticRenderFns } from "./footerQuestions.vue?vue&type=template&id=562a1eee&scoped=true"
import script from "./footerQuestions.vue?vue&type=script&lang=js"
export * from "./footerQuestions.vue?vue&type=script&lang=js"
import style0 from "./footerQuestions.vue?vue&type=style&index=0&id=562a1eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562a1eee",
  null
  
)

export default component.exports